import { useEffect, useState } from "react";
import { Type } from "lucide-react";
import { applyFontSize, FontSizeScale, getSavedFontSize, FONT_SIZE_LABELS } from "@/lib/font-size";
import { toast } from "sonner";

export function FontSizeToggle({ className = "" }: { className?: string }) {
  const [currentSize, setCurrentSize] = useState<FontSizeScale>("normal");

  useEffect(() => {
    const saved = getSavedFontSize();
    setCurrentSize(saved);
    applyFontSize(saved);
  }, []);

  const cycleFontSize = () => {
    const order: FontSizeScale[] = ["normal", "large", "xlarge"];
    const nextIndex = (order.indexOf(currentSize) + 1) % order.length;
    const nextSize = order[nextIndex];
    applyFontSize(nextSize);
    setCurrentSize(nextSize);
    toast.info(`เปลี่ยนขนาดตัวอักษรเป็น: ${FONT_SIZE_LABELS[nextSize].name} (${FONT_SIZE_LABELS[nextSize].size})`, {
      duration: 1800,
    });
  };

  return (
    <button
      onClick={cycleFontSize}
      type="button"
      className={`inline-flex items-center gap-1 sm:gap-1.5 px-2 py-1 sm:px-3 sm:py-1.5 rounded-full border border-slate-200 bg-white/90 hover:bg-emerald-50 hover:border-emerald-300 text-slate-700 hover:text-emerald-800 transition-all shadow-xs active:scale-95 shrink-0 ${className}`}
      title={`ขนาดตัวอักษรปัจจุบัน: ${FONT_SIZE_LABELS[currentSize].name} (คลิกเพื่อเปลี่ยน)`}
      aria-label="เปลี่ยนขนาดตัวอักษร"
      aria-live="polite"
    >
      <Type size={14} className="text-emerald-700 shrink-0" />
      <span className="text-xs font-black text-slate-800">
        {currentSize === "normal" ? "A" : currentSize === "large" ? "A+" : "A++"}
      </span>
      <span className="text-[11px] font-bold text-slate-500 hidden sm:inline">
        {FONT_SIZE_LABELS[currentSize].name}
      </span>
    </button>
  );
}
